import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from "../actions/website-actions";
import {Helmet} from "react-helmet";

class Pager extends Component {

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  changePage(evt,pge) {

    //evt.preventDefault();
    //this.getProfiles(pge);
  }

  getBaseUrl() {
    let sUrl = "https://www.dummy.com" + this.props.WebPage.ServerParams.Path + this.props.WebPage.ServerParams.Query;
    if(typeof window !== "undefined") {
      sUrl = window.location.href;
    }
    return sUrl;
  }

  removeParameterFromUrl(url, parameter) {
    return url
      .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
      .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
  }

  buildQuery(currentLoc,pge) { //ONLY filter/term/page Are Allow'd In Query's
    let bUrl = this.getBaseUrl();
    let fil = wActs.getParameterByName("filter",bUrl,"");
    let trm = wActs.getParameterByName("term",bUrl,"");
    let cc = wActs.getParameterByName("country",bUrl,"");
    let cty = wActs.getParameterByName("city",bUrl,"");
    let nLoc = currentLoc;
    nLoc += `?page=${pge}${trm !== "" ? "&term=" + encodeURIComponent(trm) : ""}${fil !== "" ? "&filter=" + encodeURIComponent(fil) : ""}${cc !== "" ? "&country=" + encodeURIComponent(cc) : ""}${cc !== "" ? "&city=" + encodeURIComponent(cty) : ""}`;
    return nLoc;
  }

  getPagePath(pge) {
    let currentLoc = "";
    if(pge == 1) { //Do Not Do Query On Page 1
      if(typeof document === "undefined") {
        return this.props.WebPage.ServerParams.Path;
      } else {
        return document.location.pathname;
      }
    }
    if(typeof document === "undefined") {
      currentLoc = this.props.WebPage.ServerParams.Path
    } else {
      currentLoc = `${document.location.pathname}`;
    }
    return this.buildQuery(currentLoc,pge); //Rebuild Query Removing All Nonsense...
  }

  getPageLocation(pge) {
    let currentLoc = "";
    if(pge == 1) { //Do Not Do Query On Page 1
      if(typeof document === "undefined") {
        return this.props.WebPage.Settings.Url + (this.props.WebPage.ServerParams.Path == "/" ? "" : this.props.WebPage.ServerParams.Path);
      } else {
        return document.location.href.split("?")[0];
      }
    }
    if(typeof document === "undefined") {
      currentLoc = this.props.WebPage.Settings.Url + this.props.WebPage.ServerParams.Path
    } else {
      currentLoc = `https://${document.location.hostname}${document.location.pathname}`;
    }
    return this.buildQuery(currentLoc,pge); //Rebuild Query Removing All Nonsense...
  }


  render() {
    let hasNext = true;
    let hasLast = true;

    let pges = [];
    let NextPage = parseInt(this.props.Page, 10)+1;
    let LastPage = parseInt(this.props.Page, 10)-1;
    if(NextPage > this.props.TotalPages) {hasNext = false; NextPage = 1; }
    if(LastPage <=0 ) { hasLast = false; LastPage = this.props.TotalPages; }
    let StartPage = this.props.Page;
    if(this.props.TotalPages - this.props.ShowPages < StartPage) {
      StartPage = this.props.TotalPages - this.props.ShowPages;
    }
    if(StartPage <= 0) { StartPage = 1; }
    let EndPage = StartPage + this.props.ShowPages;
    if(EndPage > this.props.TotalPages) {
      EndPage = this.props.TotalPages;
    }
    for(let x=StartPage; x<=EndPage; x++) {
      let pge = <li key={"pager" + x}><Link to={this.getPagePath(x)} key={"pager"+x} onClick={(e)=>this.changePage(e,x)} title={"Page " + x}>{x}</Link></li>;
      if(x===this.props.Page) {
        pge = <li key={"pager" + x}><span key={"pager"+x} className="current" title={"Page " + x}>{x}</span></li>;
      }
      pges.push(pge);
    }
    return (
      <div className="pagination" style={{ clear: "both" }}>
        <div className="cell x12">
        <Helmet>
          {this.props.Page != 1 &&
          <meta name={"description"} content={`${this.props.Page}-${this.props.TotalPages} (${this.props.Count}) ${this.props.WebPage.Page.Description}`}/>
          }
          {this.props.Page != 1 &&
          <meta property={"og:description"}
                content={`${this.props.Page}-${this.props.TotalPages} (${this.props.Count}) ${this.props.WebPage.Page.Description}`}/>
          }
          {this.props.Page != 1 &&
          <meta name={"twitter:description"} content={`${this.props.Page}-${this.props.TotalPages} (${this.props.Count}) ${this.props.WebPage.Page.Description}`}/>
          }
          {hasLast &&
          <link rel="prev" href={this.getPageLocation(LastPage)} />
          }
          {hasNext &&
          <link rel="next" href={this.getPageLocation(NextPage)} />
          }
        </Helmet>
          <ul>
            {hasLast &&
            <li><Link rel={"prev"} to={this.getPagePath(LastPage)} key={"last"+LastPage} onClick={(e)=>this.changePage(e,LastPage)} title={"Page " + LastPage}><i className="fa fa-angle-left"></i></Link></li>
            }
            {pges}
            {hasNext &&
            <li><Link rel={"next"} to={this.getPagePath(NextPage)} key={"next"+NextPage} onClick={(e)=>this.changePage(e,NextPage)} title={"Page " + NextPage}><i className="fa fa-angle-right"></i></Link></li>
            }
          </ul>
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Pager);
